module.exports = __webpack_public_path__ + "static/media/grading-system.a1ae8fdc.png";